module.exports = __webpack_public_path__ + "img/QR.3e6a5ba9.png";